import { Component, ReactNode, PropsWithChildren } from 'react';
import { BacktoHomeErrorMessage } from './DefaultPageErrorMessage';

type PageErrorBoundaryProps = PropsWithChildren<{
  failback?: ReactNode;
}>;
type PageErrorBoundaryState = {
  hasError: boolean;
};

export class PageErrorBoundary extends Component<PageErrorBoundaryProps, PageErrorBoundaryState> {
  constructor(props: PageErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return this.props.failback || <BacktoHomeErrorMessage />;
    }

    return this.props.children;
  }
}
